import { memo } from 'react';
import { IconWrapper } from 'src/modules/common/icons/IconWrapper.tsx';

export const WarningIconUnfilled = memo(() => (
    <IconWrapper>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
            <path
                // eslint-disable-next-line
                d="M0.550049 16.625L9.99718 1L19.4443 16.625H0.550049ZM2.05448 15.7917H17.9399L9.99718 2.5625L2.05448 15.7917ZM10.3709 13.9833C10.4797 13.8781 10.5342 13.7536 10.5342 13.6096C10.5342 13.4657 10.4816 13.3393 10.3764 13.2305C10.2711 13.1216 10.1466 13.0672 10.0027 13.0672C9.85873 13.0672 9.73234 13.1198 9.62349 13.225C9.51463 13.3302 9.46021 13.4548 9.46021 13.5987C9.46021 13.7426 9.51281 13.869 9.61802 13.9779C9.72323 14.0867 9.84779 14.1411 9.99172 14.1411C10.1356 14.1411 10.262 14.0885 10.3709 13.9833ZM9.58052 11.8172H10.4139V6.81719H9.58052V11.8172Z"
            />
        </svg>
    </IconWrapper>
));
